import { Helmet } from "react-helmet-async";

export default function SEO({
  title,
  description,
  keywords,
  image,
  ogTitle,
  ogDescription,
}) {
  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />

      {keywords && <meta name="keywords" content={keywords} />}

      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />

      {image && <meta property="og:image" content={image} />}
    </Helmet>
  );
}
